export default {
  outList: [
    {
      light_point_2:[
        {
          title: '全场景智控四驱系统',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '高通骁龙8155智能车规级芯片，采用7纳米工艺，秒开机，丝滑不卡顿'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '配备10大冠军科技',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '让您与爱车的沟通、交互变得更为简单'
        },
      ],
      light_point_2:[
        {
          title: '24.6吋寰宇星云沉浸环绕屏+',
          type: 'image',
          video: '',
          image: 'lightPoint/1/5.jpg',
          text: '24.6吋超清双联屏，画面更真实，体验更沉浸'
        },
      ],
      light_point_3:[
        {
          title: 'W-HUD星际飞行式平视显示',
          type: 'image',
          video: '',
          image: 'lightPoint/in/3.png',
          text: '悬浮显示科技，平视显示，不必低头，就能在车窗上看到重要信息，视线聚焦，利于轻松安全驾驶'
        }
      ],
      light_point_4:[
        {
          title: '星河环绕氛围灯组',
          type: 'image',
          video: '',
          image: 'lightPoint/in/4.png',
          text: '超级天幕氛围灯：贯穿天幕两侧，营造高档科技格调，打造独一无二的驾享体验'
        }
      ],
      light_point_5:[
        {
          title: 'SONY豪华8扬声器',
          type: 'image',
          video: '',
          image: 'lightPoint/1/6.jpg',
          text: '“金耳朵”大师级调音与高端8扬系统，属于您的专属音乐厅'
        },
      ]
    }
  ],
  tab1:[
    {
      title: '配备10大冠军科技',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '让您与爱车的沟通、交互变得更为简单'
    },
    {
      title: '高通骁龙8155智能芯片+',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '秒开机，丝滑不卡顿'
    },
    {
      title: '无重力女皇适能座驾',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '无缝式电动腿托，背部气动按摩 护腰护颈护膝，随时随地享受SPA级按摩享受，激发「暖男」时刻'
    },
    {
      title: 'L2.5级智能驾驶辅助+',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '高速巡航轻松不累，日常行驶安全无盲区'
    },
    {
      title: '24.6吋寰宇星云沉浸环绕屏+',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '24.6吋超清双联屏，画面更真实，体验更沉浸'
    },
    {
      title: 'SONY豪华8扬声器',
      type: 'image',
      video: '',
      image: 'lightPoint/1/6.jpg',
      text: '“金耳朵”大师级调音与高端8扬系统，属于您的专属音乐厅'
    },
    {
      title: '50W手机快速无线充电',
      type: 'image',
      video: '',
      image: 'lightPoint/1/7.jpg',
      text: '即放即充，便利高效告别电线困扰'
    }

  ],
  tab2: [
    {
      title: '全场景智控四驱系统',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '高通骁龙8155智能车规级芯片，采用7纳米工艺，秒开机，丝滑不卡顿'
    }
  ]
}
